export default __webpack_public_path__ + "static/media/linked in profile pic - Preetham A.2ddfbddc.jpeg";